<ui-card-page>
	<ng-container modal-header>
		<div style="margin-top: 40%;" class="resume_header">
			<div class="resume_header__images">
				<img style="width: 124px;" [src]="'assets/images/ibk-icon-error.png' | locationAssets" alt="ibk"/>
			</div>
		</div>
	</ng-container>
	<ng-container modal-subtitle>
	</ng-container>
	@if (cookieService.cookiesBlocked()) {
	<ng-container modal-body>
		<div class="resumen_body">
			<div class="resumen_body__cardholder">
				<div class="resume_header__title_error">{{ this.pegp.form_error.title }}</div>
				<div class="resume_header__text_error" style="margin-top: 16px;">Tu navegador tiene las cookies bloqueadas.</div>
				<div class="resume_header__text_error">Actívalas en la configuración y </div>
				<div class="resume_header__text_error">solicita nuevamente el enlace de pago con AVI.</div>
			</div>
			<div class="resumen_body__form">
				<a href="https://interbank.pe/"
				   style="display:inline-block;width: 248px;text-decoration: inherit;text-align: center"
				   class="ibk-btn ibk-btn--primary">
					{{ this.pegp.form_error.acceptButtonTitle }}
				</a>
			</div>
		</div>
	</ng-container>

	} @else {
	<ng-container modal-body>
		<div class="resumen_body">
			<div class="resumen_body__cardholder">
				<div class="resume_header__title_error">{{ this.pegp.form_error.title }}</div>
				<div class="resume_header__text_error" style="margin-top: 16px;">{{ this.pegp.form_error.subtitle0 }}</div>
				<div class="resume_header__text_error">{{ this.pegp.form_error.subtitle1 }}</div>
				<div class="resume_header__text_error">{{ this.pegp.form_error.subtitle2 }}</div>
			</div>
			<div class="resumen_body__form">
				<a href="https://interbank.pe/"
				   style="display:inline-block;width: 248px;text-decoration: inherit;text-align: center"
				   class="ibk-btn ibk-btn--primary">
					{{ this.pegp.form_error.acceptButtonTitle }}
				</a>
			</div>
		</div>
	</ng-container>
	}

</ui-card-page>
